import React from "react";
import { Box, Button, Typography } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { ImageCropper } from "../ImageCropper";
import { ImageCropState } from "../../hooks/useImageCrop";

type Props = {
  inputId: string;
  inputName: string;
  imageCrop: ImageCropState;
  file: File | string | null | undefined;
  error?: string;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemove?: () => void;
};

const isFilePdf = (file: File | string | null | undefined): boolean => {
  if (!file) return false;
  if (file instanceof File) return file.name?.toLowerCase().endsWith(".pdf");
  return typeof file === "string" && file.toLowerCase().endsWith(".pdf");
};

export const DocumentFileField = ({
  inputId,
  inputName,
  imageCrop,
  file,
  error,
  onFileChange,
  onRemove,
}: Props) => {
  const showRemove = !!onRemove && (!!file || !!imageCrop.imageToUpload);

  return (
    <>
      <div className="labelMainDiv">
        <label htmlFor={inputId} className="lableForImage">
          Datei ausw&auml;hlen
        </label>
        {!file && !imageCrop.imageToUpload && (
          <label className="labelselectfile">keine Datei</label>
        )}
      </div>
      <input
        type="file"
        name={inputName}
        id={inputId}
        hidden
        onChange={onFileChange}
      />
      <div>
        {isFilePdf(file) ? (
          <Box sx={{ mt: 2 }}>
            <a
              href={file instanceof File ? "#" : (file as string)}
              target="_blank"
              rel="noreferrer"
            >
              PDF-Dokument
            </a>
          </Box>
        ) : (
          <div style={{ marginTop: "1rem" }}>
            <div className="CropContainer">
              {imageCrop.imageToUpload ? (
                <ImageCropper
                  imagePreview={imageCrop.imagePreview}
                  onCropComplete={imageCrop.onCropComplete}
                  rotation={imageCrop.rotation}
                  onRotationChange={imageCrop.setRotation}
                  zoom={imageCrop.zoom}
                  onZoomChange={imageCrop.setZoom}
                />
              ) : (
                file &&
                typeof file === "string" && (
                  <img
                    alt=""
                    src={file}
                    style={{
                      maxHeight: "150px",
                      maxWidth: "270px",
                      objectFit: "contain",
                    }}
                  />
                )
              )}
            </div>
          </div>
        )}
      </div>
      {showRemove && (
        <Button
          size="small"
          color="error"
          startIcon={<DeleteOutlineIcon />}
          onClick={onRemove}
          sx={{ mt: 1, textTransform: "none" }}
        >
          Datei entfernen
        </Button>
      )}
      {error && (
        <Typography variant="caption" color="error" display="block">
          {error}
        </Typography>
      )}
    </>
  );
};
